var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.707 7.793a1 1 0 010 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414L10 10.086l2.293-2.293a1 1 0 011.414 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy43MDcxIDcuNzkyODlDMTQuMDk3NiA4LjE4MzQyIDE0LjA5NzYgOC44MTY1OCAxMy43MDcxIDkuMjA3MTFMMTAuNzA3MSAxMi4yMDcxQzEwLjMxNjYgMTIuNTk3NiA5LjY4MzQyIDEyLjU5NzYgOS4yOTI4OSAxMi4yMDcxTDYuMjkyODkgOS4yMDcxMUM1LjkwMjM3IDguODE2NTggNS45MDIzNyA4LjE4MzQyIDYuMjkyODkgNy43OTI4OUM2LjY4MzQyIDcuNDAyMzcgNy4zMTY1OCA3LjQwMjM3IDcuNzA3MTEgNy43OTI4OUwxMCAxMC4wODU4TDEyLjI5MjkgNy43OTI4OUMxMi42ODM0IDcuNDAyMzcgMTMuMzE2NiA3LjQwMjM3IDEzLjcwNzEgNy43OTI4OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgArrow as ReactComponent };